export const tennessee = {
  "47000": "Tennessee",
  "47001": "Anderson County",
  "47003": "Bedford County",
  "47005": "Benton County",
  "47007": "Bledsoe County",
  "47009": "Blount County",
  "47011": "Bradley County",
  "47013": "Campbell County",
  "47015": "Cannon County",
  "47017": "Carroll County",
  "47019": "Carter County",
  "47021": "Cheatham County",
  "47023": "Chester County",
  "47025": "Claiborne County",
  "47027": "Clay County",
  "47029": "Cocke County",
  "47031": "Coffee County",
  "47033": "Crockett County",
  "47035": "Cumberland County",
  "47037": "Davidson County",
  "47039": "Decatur County",
  "47041": "DeKalb County",
  "47043": "Dickson County",
  "47045": "Dyer County",
  "47047": "Fayette County",
  "47049": "Fentress County",
  "47051": "Franklin County",
  "47053": "Gibson County",
  "47055": "Giles County",
  "47057": "Grainger County",
  "47059": "Greene County",
  "47061": "Grundy County",
  "47063": "Hamblen County",
  "47065": "Hamilton County",
  "47067": "Hancock County",
  "47069": "Hardeman County",
  "47071": "Hardin County",
  "47073": "Hawkins County",
  "47075": "Haywood County",
  "47077": "Henderson County",
  "47079": "Henry County",
  "47081": "Hickman County",
  "47083": "Houston County",
  "47085": "Humphreys County",
  "47087": "Jackson County",
  "47089": "Jefferson County",
  "47091": "Johnson County",
  "47093": "Knox County",
  "47095": "Lake County",
  "47097": "Lauderdale County",
  "47099": "Lawrence County",
  "47101": "Lewis County",
  "47103": "Lincoln County",
  "47105": "Loudon County",
  "47107": "McMinn County",
  "47109": "McNairy County",
  "47111": "Macon County",
  "47113": "Madison County",
  "47115": "Marion County",
  "47117": "Marshall County",
  "47119": "Maury County",
  "47121": "Meigs County",
  "47123": "Monroe County",
  "47125": "Montgomery County",
  "47127": "Moore County",
  "47129": "Morgan County",
  "47131": "Obion County",
  "47133": "Overton County",
  "47135": "Perry County",
  "47137": "Pickett County",
  "47139": "Polk County",
  "47141": "Putnam County",
  "47143": "Rhea County",
  "47145": "Roane County",
  "47147": "Robertson County",
  "47149": "Rutherford County",
  "47151": "Scott County",
  "47153": "Sequatchie County",
  "47155": "Sevier County",
  "47157": "Shelby County",
  "47159": "Smith County",
  "47161": "Stewart County",
  "47163": "Sullivan County",
  "47165": "Sumner County",
  "47167": "Tipton County",
  "47169": "Trousdale County",
  "47171": "Unicoi County",
  "47173": "Union County",
  "47175": "Van Buren County",
  "47177": "Warren County",
  "47179": "Washington County",
  "47181": "Wayne County",
  "47183": "Weakley County",
  "47185": "White County",
  "47187": "Williamson County",
  "47189": "Wilson County",
};
